import { put, takeEvery } from "redux-saga/effects";
import { useSelector, useDispatch } from "react-redux";
import * as types from "../types";

import { getTanscriptsApiData, editTranscriptDataApi } from "redux/agent";

function* getTranscriptsDataSaga(action) {
  try {
    yield put({
      type: types.SET_LOADER,
      payload: true,
    });
    let response = yield getTanscriptsApiData(action.payload);
    const apiResponse = response.data;
    console.log("apiResponse", apiResponse);
    yield put({
      type: types.GET_TRANSCRIPTS_DATA_SUCCESS,
      payload: response.data.results,
    });
  } catch (error) {
    console.log("err", error);
    if (
      (error.response.status === 400 &&
        error.response.data.message === "Invalid token") ||
      (error.response.status === 403 &&
        error.response.data.message === "Invalid token")
    ) {
      yield put({
        type: types.USER_LOGOUT,
      });
    } else {
      yield put({
        type: types.GET_TRANSCRIPTS_DATA_FAILED,
        payload: { status: error.status },
      });
    }
  } finally {
    yield put({
      type: types.SET_LOADER,
      payload: false,
    });
  }
}

function* putTranscriptDataChange(action) {
  try {
    let response = yield editTranscriptDataApi(action.payload);
    console.log("Response at saga", response);
    yield put({
      type: types.PUT_EDIT_TRANSCRIPTS_DATA_SUCCESS,
      payload: { isDataUpdated: true },
    });
    yield put({
      type: types.OPEN_UPDATE_MODAL,
      payload: "QA data updated successfully",
      // payload: "Transcript data updated successfully",
    });
  } catch (err) {
    console.log("err", err);

    yield put({
      type: types.PUT_EDIT_TRANSCRIPTS_DATA_FAILED,
      payload: { isDataUpdated: false },
    });
  }
}

function* getTranscripts() {
  yield takeEvery(types.GET_TRANSCRIPTS_DATA, getTranscriptsDataSaga);
  yield takeEvery(types.PUT_EDIT_TRANSCRIPTS_DATA, putTranscriptDataChange);
}

export default getTranscripts;
